import { t } from '@gem/modules/i18n';

import { PayloadType } from 'APP/model/message/messageModel.types';
import Entities from 'STORE';

import { Payload } from '../Payload';

export class ContactPayload extends Payload {
  userId;
  phone;
  name;
  avatarUrl;
  appContact;

  constructor(data) {
    super({ ...data, payloadType: PayloadType.Contact });

    this.userId = data.userId;
    this.phone = data.phone;
    this.name = data.name;
    this.avatarUrl = data.avatarUrl;
    this.appContact = data.appContact;
  }

  toJSON() {
    return {
      ...super.toJSON(),
      userId: this.userId || null,
      phone: this.phone || null,
      name: this.name,
      avatarUrl: this.avatarUrl || null,
      appContact: this.appContact,
    };
  }

  get text() {
    return t('share_contact_quoted_type');
  }

  get user() {
    return Entities.usersStore.getUserById(this.userId);
  }

  get typeDescription() {
    return t('share_contact_quoted_type');
  }

  get showStartChatButton() {
    return (
      (!this.message.fromMe || this.message.isSavedMessagesLeft) &&
      Entities.usersStore.Me.id !== this.userId &&
      this.appContact
    );
  }
}
